export const findEarliestExpiringBatches = (allBatches) => {
    // Filter out batches without expiry date or with zero quantity
    const validBatches = allBatches.filter(batch => 
      batch.expiry_date && 
      batch.quantity.some(q => q.value > 0)
    );
  
    // If no valid batches, return empty array
    if (validBatches.length === 0) return [];
  
    // Separate batches with and without expiry dates
    const batchesWithExpiry = validBatches.filter(batch => batch.expiry_date);

    // Find the earliest expiry date
    const earliestExpiryDate = Math.min(
      ...batchesWithExpiry.map(batch => new Date(batch.expiry_date).getTime())
    );

    const earliestBatches = batchesWithExpiry.filter(batch => 
      new Date(batch.expiry_date).getTime() === earliestExpiryDate
    );
    return [...earliestBatches];
  };


   // const isEarliestExpiringBatch = (row, allBatches) => {
  //   // Finding earliest expiry date among all batches
  //   const earliestExpiryDate = Math.min(
  //     ...allBatches.map(batch => new Date(batch.expiry_date).getTime())
  //   );
  
  //   // Check if the selected batch has the earliest expiry date
  //   return new Date(row.expiry_date).getTime() === earliestExpiryDate;
  // };